const classIdSplit = /([\.#]?[a-zA-Z0-9\u007F-\uFFFF_:-]+)/
const notClassId = /^\.|#/
const { createElement, Children } = require('react')

const rename = {
  onchange: 'onChange',
  onclick: 'onClick',
  onsubmit: 'onSubmit',
  onkeyup: 'onKeyUp',
  onkeydown: 'onKeyDown',
  onkeypress: 'onKeyPress',
  onmouseup: 'onMouseUp',
  onmousedown: 'onMouseDown',
  onmousemove: 'onMouseMove',
  onmouseover: 'onMouseOver',
  onmouseout: 'onMouseOut',
  onmouseenter: 'onMouseEnter',
  onmouseleave: 'onMouseLeave',
  onfocus: 'onFocus',
  onblur: 'onBlur',
  oninput: 'onInput',
  autofocus: 'autoFocus',
  autocomplete: 'autoComplete',
  autocorrect: 'autoCorrect',
  autocapitalize: 'autoCapitalize',
  spellcheck: 'spellCheck',
  readonly: 'readOnly',
  'xlink:href': 'xlinkHref',
  'margin-top': 'marginTop',
  'margin-right': 'marginRight',
  'margin-bottom': 'marginBottom',
  'margin-left': 'marginLeft',
  'padding-top': 'paddingTop',
  'padding-right': 'paddingRight',
  'padding-bottom': 'paddingBottom',
  'padding-left': 'paddingLeft',
  'colspan': 'colSpan',
  'rowspan': 'rowSpan',
  'class': 'className',
  'text-anchor': 'textAnchor',
  'font-size': 'fontSize',
  'font-weight': 'fontWeight',
  'max-width': 'maxWidth',
  'min-width': 'minWidth',
  'max-height': 'maxHeight',
  'min-height': 'minHeight',
  'text-align': 'textAlign',
  'max-width': 'maxWidth',
  'min-width': 'minWidth',
  'max-height': 'maxHeight',
  'min-height': 'minHeight',
  'for': 'htmlFor'
}

const renameAll = a => {
  for (const key in a) {
    if (rename[key] == null) continue
    a[rename[key]] = a[key]
    delete a[key]
  }
}

module.exports = (element, data, children) => {
  if (data != null
    && typeof(data) == 'object'
    && !Array.isArray(data)) {
      if (data.attributes != null
        && typeof(data.attributes) == 'object') {
        Object.assign(data, data.attributes)
        delete data.attributes
      }
      renameAll(data)
      if (data.style != null) renameAll(data.style)
    }
  // support h('div', [ ]) syntax (optional params)
  if (data == null || typeof(data) != 'object' || Array.isArray(data) || data['$$typeof'] != null) {
    children = data
    data = {}
  }
  if (children) {
    if (!Array.isArray(children)) children = [children]
    children = Children.toArray(children.flat())
  }
  // null means div
  if (element == null) return createElement('div', data, children)
  // support h(Component) syntax
  if (typeof(element) != 'string') return createElement(element, data, children)

  // parse parts and assign to classes and id
  const parts = element.split(classIdSplit)
  for (let part of parts) {
    const type = part.charAt(0)
    const value = part.substring(1, part.length)

    if (type === '.') {
      if (!data.className)
        data.className = value
      else
        data.className = `${data.className} ${value}`
    }
    else if (type === '#' && !data.hasOwnProperty('id')) {
      data.id = value
    }
  }

  // default to div
  const tag = notClassId.test(parts[1])
    ? 'div'
    : parts[1]
  return createElement(tag, data, children)
}